import React, { useMemo, useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Lines, { ANIMATION_INTERVALS_COUNT } from './Lines';
import Item from './Item';
import makeIconName from '../../../utils/makeIconName';
import { ICONS } from '../../../constants/icons';
import styles from './index.module.scss';
import './anim.scss';
const ENTER_KEYDOWN = 13;
const ANIMATION_INTERVAL = 5000;
const ANIMATION_SPEED = ANIMATION_INTERVAL / ANIMATION_INTERVALS_COUNT;
const TestimonialsCarousel = ({ itemsList, isFullWidth }) => {
    const [currentElement, setCurrentElement] = useState(Object.assign(Object.assign({}, itemsList[0]), { index: 0 }));
    const [prevIndex, setPrevIndex] = useState(-1);
    const [currentInterval, setCurrentInterval] = useState(0);
    const [animHoldStart, setAnimHoldStart] = useState(null);
    const [animHoldFinish, setAnimHoldFinish] = useState(null);
    const IS_MANUAL_CLICK = useRef(false);
    const classes = classnames({
        [styles.carouselWrap]: true,
        [styles.fullWidth]: isFullWidth
    });
    const _updatePrevIndex = (nextIndex) => {
        setPrevIndex(() => {
            return nextIndex - 1;
        });
    };
    const _updateCurrentElementOnScreen = () => {
        setCurrentElement((element) => {
            const isLastElement = element.index === itemsList.length - 1;
            _updatePrevIndex(element.index);
            return Object.assign(Object.assign({}, itemsList[isLastElement ? 0 : element.index + 1]), { index: isLastElement ? 0 : element.index + 1 });
        });
    };
    const _updateCurrentInterval = () => {
        setCurrentInterval((value) => {
            const isMaxIntervalReached = value === ANIMATION_INTERVALS_COUNT;
            if (isMaxIntervalReached) {
                _updateCurrentElementOnScreen();
                return Math.abs(value - ANIMATION_INTERVALS_COUNT) || 1;
            }
            return value + 1;
        });
    };
    const _handleMouseDown = () => {
        IS_MANUAL_CLICK.current = true;
        setAnimHoldStart(Date.now());
    };
    const _handleMouseUp = () => {
        IS_MANUAL_CLICK.current = false;
        setAnimHoldFinish(Date.now());
    };
    const _handleMouseLeave = () => {
        if (IS_MANUAL_CLICK.current) {
            IS_MANUAL_CLICK.current = false;
        }
    };
    const _handleClick = () => {
        // if between down and up event spend more than 300ms
        // we assume that user would like to read by holding the carousel progress
        if (animHoldFinish - animHoldStart >= 300) {
            return;
        }
        _updateCurrentElementOnScreen();
        setCurrentInterval(0);
    };
    const _handleKeyDown = (e) => e.keyCode === ENTER_KEYDOWN && _handleClick();
    useEffect(() => {
        const TIMER = setInterval(() => {
            if (IS_MANUAL_CLICK.current) {
                return;
            }
            _updateCurrentInterval();
        }, ANIMATION_SPEED);
        return () => clearInterval(TIMER);
    }, []);
    const renderNonVisibleList = useMemo(() => {
        // for SEO purposes
        return itemsList.filter((_, index) => index !== currentElement.index);
    }, [currentElement, itemsList]);
    return (React.createElement("div", { className: classes, onMouseDown: _handleMouseDown, onTouchStart: _handleMouseDown, onMouseUp: _handleMouseUp, onTouchEnd: _handleMouseUp, onMouseLeave: _handleMouseLeave, onBlur: _handleMouseLeave, onClick: _handleClick, onKeyDown: _handleKeyDown, tabIndex: 0, role: 'button' },
        React.createElement("div", { className: styles.leftSection },
            React.createElement("i", { className: `${makeIconName(ICONS.x32.quote, 'x32')} ${styles.icon}` })),
        React.createElement("div", { className: styles.rightSection },
            React.createElement(TransitionGroup, { className: 'animationReplacerWrap' },
                React.createElement(CSSTransition, { classNames: 'animationReplacer', timeout: 300, key: currentElement.index, unmountOnExit: true },
                    React.createElement(Item, { item: currentElement }))),
            renderNonVisibleList.map((item) => (React.createElement(Item, { item: item, isHidden: true, key: item.author }))),
            React.createElement(Lines, { itemsCount: itemsList.length, prevIndex: prevIndex, currentElement: currentElement, currentInterval: currentInterval }))));
};
export default TestimonialsCarousel;
